"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPermission = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var checkPermission = function checkPermission(principal, resourceType, resourceId, permission, accessToken) {
  return _axios["default"].get("https://api.cimpress.io/auth/access-management/v1/principals/".concat(encodeURIComponent(principal), "/permissions/").concat(resourceType, "/").concat(resourceId, "/").concat(permission), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.status === 204;
  })["catch"](function () {
    return false;
  });
};
exports.checkPermission = checkPermission;